// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add Spot Trading Coin Page */
.addcoin-loading,
.addcoin-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 3rem 1.5rem;
  color: var(--text-muted);
  font-size: 0.95rem;
}

.addcoin-error {
  text-align: center;
}

.addcoin-error p {
  margin: 0;
}

.addcoin-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.addcoin-alert {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-radius: 10px;
  font-size: 0.9rem;
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.addcoin-alert--error i {
  font-size: 1.1rem;
  flex-shrink: 0;
}

.addcoin-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  padding: 1.5rem;
}

.addcoin-card__title {
  margin: 0 0 1rem 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.addcoin-card__title i {
  color: #0f766e;
}

.addcoin-card__desc {
  margin: 0 0 1rem 0;
  font-size: 0.875rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.addcoin-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem 1.25rem;
}

.addcoin-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.addcoin-field--full {
  grid-column: 1 / -1;
}

.addcoin-field label {
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--text);
}

.addcoin-required {
  color: #dc2626;
}

.addcoin-field input[type="text"],
.addcoin-field input[type="number"],
.addcoin-field input[type="file"],
.addcoin-field select,
.addcoin-textarea {
  padding: 0.6rem 0.85rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
  transition: border-color 0.15s ease;
}

.addcoin-field input:focus,
.addcoin-field select:focus,
.addcoin-textarea:focus {
  outline: none;
  border-color: #0f766e;
  box-shadow: 0 0 0 2px rgba(15, 118, 110, 0.15);
}

.addcoin-field input.addcoin-input--error,
.addcoin-field select.addcoin-input--error {
  border-color: #dc2626;
  background: #fef2f2;
}

.addcoin-textarea {
  resize: vertical;
  min-height: 80px;
}

.addcoin-hint {
  font-size: 0.75rem;
  color: var(--text-muted);
}

.addcoin-error-msg {
  font-size: 0.75rem;
  color: #dc2626;
  margin-top: 0.15rem;
}

.addcoin-file-preview {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  color: #16a34a;
  margin-top: 0.25rem;
}

.addcoin-chains {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.addcoin-chain-chip {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  padding: 0.75rem 1.25rem;
  border: 2px solid var(--border);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fff;
}

.addcoin-chain-chip:hover {
  border-color: #0f766e;
  background: #f0fdfa;
}

.addcoin-chain-chip--active {
  border-color: #0f766e;
  background: #ccfbf1;
}

.addcoin-chain-chip input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.addcoin-chain-network {
  font-size: 0.7rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.addcoin-chain-block {
  padding: 1.25rem;
  background: #f8fafc;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  margin-bottom: 1rem;
}

.addcoin-chain-block:last-child {
  margin-bottom: 0;
}

.addcoin-chain-block__title {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: 700;
  color: var(--text);
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.addcoin-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 0.5rem;
}

.addcoin-actions .btn {
  min-width: 140px;
}

.addcoin-actions .btn i {
  margin-right: 0.5rem;
}

/* Success modal */
.addcoin-success-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.addcoin-success-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.75rem;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.addcoin-success-icon {
  font-size: 3rem;
  color: #16a34a;
  margin-bottom: 0.75rem;
}

.addcoin-success-title {
  margin: 0 0 0.5rem 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text);
}

.addcoin-success-desc {
  margin: 0 0 1.25rem 0;
  font-size: 0.95rem;
  color: var(--text-muted);
}

.addcoin-success-details {
  text-align: left;
  background: #f8fafc;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  margin-bottom: 1.25rem;
  border: 1px solid var(--border);
}

.addcoin-success-row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.4rem 0;
  font-size: 0.9rem;
}

.addcoin-success-row .addcoin-success-label {
  font-weight: 600;
  color: var(--text-muted);
}

.addcoin-success-btn {
  min-width: 120px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Trading/AddSpotTradingCoinPage.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;;;EAKE,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Add Spot Trading Coin Page */\n.addcoin-loading,\n.addcoin-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 3rem 1.5rem;\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\n.addcoin-error {\n  text-align: center;\n}\n\n.addcoin-error p {\n  margin: 0;\n}\n\n.addcoin-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.addcoin-alert {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 1rem 1.25rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.addcoin-alert--error i {\n  font-size: 1.1rem;\n  flex-shrink: 0;\n}\n\n.addcoin-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  padding: 1.5rem;\n}\n\n.addcoin-card__title {\n  margin: 0 0 1rem 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.addcoin-card__title i {\n  color: #0f766e;\n}\n\n.addcoin-card__desc {\n  margin: 0 0 1rem 0;\n  font-size: 0.875rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.addcoin-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1rem 1.25rem;\n}\n\n.addcoin-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.addcoin-field--full {\n  grid-column: 1 / -1;\n}\n\n.addcoin-field label {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.addcoin-required {\n  color: #dc2626;\n}\n\n.addcoin-field input[type=\"text\"],\n.addcoin-field input[type=\"number\"],\n.addcoin-field input[type=\"file\"],\n.addcoin-field select,\n.addcoin-textarea {\n  padding: 0.6rem 0.85rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n  transition: border-color 0.15s ease;\n}\n\n.addcoin-field input:focus,\n.addcoin-field select:focus,\n.addcoin-textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n  box-shadow: 0 0 0 2px rgba(15, 118, 110, 0.15);\n}\n\n.addcoin-field input.addcoin-input--error,\n.addcoin-field select.addcoin-input--error {\n  border-color: #dc2626;\n  background: #fef2f2;\n}\n\n.addcoin-textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.addcoin-hint {\n  font-size: 0.75rem;\n  color: var(--text-muted);\n}\n\n.addcoin-error-msg {\n  font-size: 0.75rem;\n  color: #dc2626;\n  margin-top: 0.15rem;\n}\n\n.addcoin-file-preview {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.8rem;\n  color: #16a34a;\n  margin-top: 0.25rem;\n}\n\n.addcoin-chains {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.addcoin-chain-chip {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0.75rem 1.25rem;\n  border: 2px solid var(--border);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: #fff;\n}\n\n.addcoin-chain-chip:hover {\n  border-color: #0f766e;\n  background: #f0fdfa;\n}\n\n.addcoin-chain-chip--active {\n  border-color: #0f766e;\n  background: #ccfbf1;\n}\n\n.addcoin-chain-chip input {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.addcoin-chain-network {\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n.addcoin-chain-block {\n  padding: 1.25rem;\n  background: #f8fafc;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  margin-bottom: 1rem;\n}\n\n.addcoin-chain-block:last-child {\n  margin-bottom: 0;\n}\n\n.addcoin-chain-block__title {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text);\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.addcoin-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 0.5rem;\n}\n\n.addcoin-actions .btn {\n  min-width: 140px;\n}\n\n.addcoin-actions .btn i {\n  margin-right: 0.5rem;\n}\n\n/* Success modal */\n.addcoin-success-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.addcoin-success-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.75rem;\n  max-width: 400px;\n  width: 90%;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);\n  text-align: center;\n}\n\n.addcoin-success-icon {\n  font-size: 3rem;\n  color: #16a34a;\n  margin-bottom: 0.75rem;\n}\n\n.addcoin-success-title {\n  margin: 0 0 0.5rem 0;\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.addcoin-success-desc {\n  margin: 0 0 1.25rem 0;\n  font-size: 0.95rem;\n  color: var(--text-muted);\n}\n\n.addcoin-success-details {\n  text-align: left;\n  background: #f8fafc;\n  border-radius: 8px;\n  padding: 1rem 1.25rem;\n  margin-bottom: 1.25rem;\n  border: 1px solid var(--border);\n}\n\n.addcoin-success-row {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 0.4rem 0;\n  font-size: 0.9rem;\n}\n\n.addcoin-success-row .addcoin-success-label {\n  font-weight: 600;\n  color: var(--text-muted);\n}\n\n.addcoin-success-btn {\n  min-width: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
